import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import { Locale } from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'// vant-ui lang
import zhCN from 'vant/lib/locale/lang/zh-CN'// vant-ui lang
import zhTW from 'vant/lib/locale/lang/zh-TW'// vant-ui lang

import enLocale from './en'
import zhLocale from './zh'
import zhTWLocale from './zh-TW'

Vue.use(VueI18n)
// Locale.use('en-US', zhCN)

// 英文首字母大写
function titleCase2(s) {
  return s.toLowerCase().replace(/\b([\w|']+)\b/g, function(word) {
    // return word.slice(0, 1).toUpperCase() + word.slice(1);
    return word.replace(word.charAt(0), word.charAt(0).toUpperCase())
  })
}
for (var i in enLocale) {
  for (var j in enLocale[i]) {
    if (enLocale[i][j]) { // 如果存在子
      if (enLocale[i][j].length > 1) {
        enLocale[i][j] = titleCase2(enLocale[i][j])
      }
    }
  }
}
// 翻译重组
const messages = {
  en: {
    ...enLocale,
    ...enUS
  },
  zh: {
    ...zhLocale,
    ...zhCN
  },
  'zh-TW': {
    ...zhTWLocale,
    ...zhTW
  }
}
export function getLanguage() {
  let language = (navigator.language || navigator.browserLanguage).split('-')[0].toLowerCase()
  const cn = (navigator.language || navigator.browserLanguage).split('-')[1].toLowerCase()
  if (language === 'zh') {
    Locale.use('zh-CN', zhCN)
    if (cn !== 'cn') {
      language = 'zh-TW'
      Locale.use('zh-TW', zhTW)
    }
  } else {
    Locale.use('en-US', enUS)
  }
  return language
}

Cookies.set('language', getLanguage())
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
})

export default i18n
